import { Assignment } from '../../../../classroom360/gradebook/v9/models/assignment.model';


export class  GradebookStatisticalAnalysisReport {
    SiteSectionId: number;
    DistrictSubjectId: number;
    TermDescription: string;
    Course: string;
    StartPeriod: number;
    SubjectTitle: string;
    TeacherName: string;
    RoomNumber: string;
    StudentCount: number;
    Selected = false;
   }

   export class ReportParameters {
    AssignmentSelection = 1;
    EnrolmentStatus = 0;
    AddressWindowEnvelop = true;
    PrintGradeForIndevedual = true;
    GroupByAssignmentType = true;
    ShowAssignmentDate = true;
    AverageMean = true;
    Marks = 1.0;
    chMarks = true;
    PrintDate: Date;
    Percentage = 1.0;
    chkPercentage = true;
    chkTerm = true;
    TermAndSem = true;
    PrintNameColumnOnly: boolean;
    PrintGridLines: boolean;
    BlankRowBetweenStudent: boolean;
    OnlyTotalsAndTermCols: boolean;
    PrintAssignmentNotes: boolean;
    BlankColAtEnd: boolean;
    ShowStudentsComments: boolean;
    ParentSinatureLines: boolean;
    Progress: boolean;
    TermQtr: boolean;
    ShowAssignmentNumber: boolean;
    Semester: boolean;
    StandardDeviation: boolean;
    MaxMinScore: boolean;
    Median: boolean;
    DroppedStudents: boolean;
    HideNameBy: boolean;
    AlsoSortByThisId: boolean;
    HideAndSortBy: number;
    Footer: boolean;
    BlankColBetweenAssignments: boolean;
    FooterMessage: string;
    ddlPercentage: string[] = ['=', '>', '<'];
    SortByID: boolean;
    SelectAssignment: string;
    classSelectionPage: boolean;
    SiteSectionIds: string = null;
    Title: string;
    Term: string;
    Teacher: string;
    Section: string;
    Period: number;
    siteSectionHeader: string;
    SelectClasses: string;
    SelectStudents: string;
    RangeScores: string;
    RangeFrom: number;
    RangeTo: number;
    ShowAYPGroups: boolean;
    ReportType: number;
    Listing: number;
    ValueReported: number;
    GroupScore: number;
    Labels: number;
    HorizantalValue: number;
    ShowLabels: boolean;
    ScoreRange: boolean;
    SpecificAssignments: Assignment[] = [];
    SpecificAssignment: Assignment;
    AssignmentTypes: GradeBookAssignmentTypeBySiteSectionIds[] = [];
    AssignmentType: GradeBookAssignmentTypeBySiteSectionIds;
    IsViewGradebookForAllTeacher: boolean;
    StatisticalAnalysisRetports: GradebookStatisticalAnalysisReport[] = [];
    ReportTitle: string;
}

export class  StatisticalAnalysisReportPreferences {
    pub_bytReportType: number;
    pub_bytListing: number;
    pub_bytValueReported: number;
    pub_bytLabels: number;
    pub_bytHorizantalValue: number;
    pub_bytselectedStudent: number;
    pub_blnShowAyp: boolean;
    pub_blnSelectRange: boolean;
    pub_blnSelectedAssignment: boolean;
    pub_blnRangeUse: boolean;
    pub_blnOverrideLineTo: boolean;
    pub_strOverrideLineToHeader: string;
    pub_strRangeFrom: string;
    pub_strRangeTo: string;
    pub_strSiteSectionIds: string;
    pub_blnAllClasses: boolean;
    pub_intScoreUseIndex: number;
    pub_intAssignmentTypeId: number;
    pub_intAssignmentSequence: number;
    pub_intGroupByInterval: number;
    pub_intSelectedAssignmentIndex: number;
    pub_intTeacherId: number;
    pub_intDistrictSubjectId: number;
    pub_blnShowLabels: boolean;
   }

   export class GradeBookAssignmentTypeBySiteSectionIds {
    Id: string;
    Code: string;
    CodeDescription: string;
    Default: boolean;
    Sequence: number;
    State: string;
   }

   export class ScoreRange {
       Value: number;
       Description: string;
   }